import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import ModalPortal from '@/src/components/common/Modal/ModalPortal';
import ConfirmRenameModal from '@/src/components/project/Common/Modals/RenameModal/ConfirmRenameModal/ConfirmRenameModal';
import RenameModal from '@/src/components/project/Common/Modals/RenameModal/RenameModal';
import { showToast } from '@/src/globalFunction';
import {
  toggleRenameConfirmModal,
  toggleRenameModal,
  setUpdatedName,
  renameDocumentFromModal,
  reset,
} from '@/src/reducers/project/renameModal/renameModal.actions';

const RenameModalContainer = ({ selected, onSave = null, customSave = null, onCancel = null }) => {
  const dispatch = useDispatch();
  const updatedName = useSelector((state) => state.renameModal.updatedName);
  const showConfirmRenameModal = useSelector((state) => state.renameModal.showConfirmModal);

  useEffect(() => {
    return () => {
      dispatch(reset());
    };
  }, [dispatch]);

  const handleSave = (updatedName) => {
    if (selected.origin === updatedName) {
      return;
    }

    if (customSave) {
      return customSave(updatedName).then((response) => {
        showToast('success', `Successfully renamed file.`);
        dispatch(toggleRenameModal(false));
        return response;
      });
    }

    if (onSave) {
      dispatch(setUpdatedName(updatedName));
      dispatch(renameDocumentFromModal(updatedName)).then((response) => {
        if (response && response.status === 200) {
          onSave(updatedName, response);
          showToast('success', `Successfully renamed file.`);
        } else {
          dispatch(toggleRenameConfirmModal(true));
        }
      });
    }
  };

  const handleConfirmSave = () => {
    const force = 1;

    dispatch(renameDocumentFromModal(updatedName, force)).then((response) => {
      if (response && response.status === 200) {
        onSave(updatedName, response);
        showToast('success', `Successfully renamed file.`);
      } else {
        showToast('error', 'Something went wrong. Please try again later.');
      }
    });
  };

  const handleCancel = () => {
    dispatch(toggleRenameModal(false));

    if (onCancel) {
      onCancel();
    }
  };

  const handleCancelConfirm = () => {
    dispatch(toggleRenameConfirmModal(false));
    dispatch(toggleRenameModal(false));
  };

  return (
    <React.Fragment>
      <RenameModal
        type="File"
        onCancel={handleCancel}
        onSave={handleSave}
        currentValue={selected.origin}
      />

      {showConfirmRenameModal && (
        <ModalPortal>
          <ConfirmRenameModal
            type="File"
            onCancel={handleCancelConfirm}
            onRename={handleConfirmSave}
          />
        </ModalPortal>
      )}
    </React.Fragment>
  );
};

export default RenameModalContainer;
